import { _, $, Backbone, moment, Radio } from "../../../../vendor";
import { Backform, Notification, Biscuit, FormatHelper } from "../../../utils";
import InboomaBaseView from "../../InboomaBaseView";
import t from "../../../react/helpers/t";
import OffCanvasBehavior from "../../../behaviors/Behavior.OffCanvas";
import {
  GetPriceHelper,
  MapProductsReservationsToSummedProducts,
  MapProductsFromRawToSave,
  MapProductsFromRawToGetPrice,
} from "./ReservationFormHelpers";
import { getApiHost } from "../../../Sync";

import ReservationItemTpl from "../../../templates/orders/ReservationForm/ReservationItemTpl.html";
import ReservationProductsList from "./ReservationProductsList";
import ProductsOverviewList from "./ProductsOverviewList";
import { getDocHandler } from "../../../utils/Helper";

/**
 * DEFAULT INBOOMA BOOKING FORM
 *
 * Used for bikesharing and appointment resourcetypes.
 * Allows selection of ONE contingent per booking.
 *
 */
export default InboomaBaseView.extend({
  _fetchingPriceInProgress: false,
  _saveRequestInProgress: false,
  showPriceWrapper: true,
  preventFromSubmit: false, // Required for external access, e.g. QuickOrderForm.js

  template: ReservationItemTpl,

  ui: {
    errorLabel: ".off-canvas__form-error.main-error",
    accordionTitle: ".accordion-title",
    accordionContent: ".accordion-content",
    reservationRequiresSave: ".reservation-requires-save",
    rollingLoader: ".rollingLoader",
    addProductBtn: ".products__add a",
    voucherFullInput: "#reservation-voucher-full-input",
    voucherFullSelect: "#reservation-voucher-full-select",
    orderExportContract: ".order_export_contract",
  },

  events: {
    "click @ui.accordionTitle": "_toggleAccordion",
    "click @ui.addProductBtn": "_toggleProductsOverviewView",
    "click @ui.orderExportContract": "_printRentalContract",
  },

  modelEvents: {
    "change:contingent_id": "onChangeContingentId",
    "change:summedProducts": "_setSummedProducts",
    "change:summedContingents": "_setSummedProducts",
    all() {
      // @todo Generify onChangeObserver in BikeReservationForm
      // and move here accordingly
      // Fetch new price from getPrice-endpoint
      this.model.set("_requiresSave", true);

      if (
        typeof this._ui !== "undefined" &&
        typeof this.getUI("reservationRequiresSave") !== "undefined"
      ) {
        this.getUI("reservationRequiresSave").removeClass("hide");
      }

      if (this.model.get("begin") !== "" && this.model.get("end") !== "") {
        this.$el.find(".button-submit-wrapper .button").removeClass("hollow");
      }

      // wait for all events happen within a very small amount of time (events that are probably triggered by an event queue)
      const that = this;
      if (!this._eventQueueStarted) {
        that._eventQueueStarted = true; // mark that event queue is running
        setTimeout(function () {
          // start timeout to wait for incoming events
          that._eventQueueStop = true;
          that._eventQueueStarted = false;
          that._fetchPrice();
        }, 100);
      }
    },
  },

  templateContext() {
    return {
      _,
      moment,
      apiHost: getApiHost().slice(0, -4),
      toggleOpen: this.options.toggleOpen || this.model.get("id") === "",
      indexNumber: this.options.indexNumber,
      showPriceWrapper: this.showPriceWrapper,
      isDefaultForm: true,
      currency: Biscuit.getClientCurrency(),
    };
  },

  initialize() {
    this.contingents = Radio.channel("contingents").request("get:data");
    this.pricetariffs = Radio.channel("pricetariffs").request("get:data");
    this.locations = Radio.channel("locations").request("get:data");
    if (typeof this.model.attributes.summedProducts === "undefined") {
      MapProductsReservationsToSummedProducts(this.model);
    }
    if (this.model.get("id") !== "") {
      const contingent = this.model.get("contingents")[0];

      // @todo Check for removed location as well as done in OrdersItemTpl

      if (
        typeof contingent !== "undefined" &&
        contingent.deleted !== null &&
        contingent.deleted !== ""
      ) {
        this.model.set("_has_any_deleted_item", true);
      }
    }
    this.render();

    // get vouchers
    const RequestHelper = Backbone.Model.extend({
      url: "/voucher_types?use_for=contingent",
    });

    const requestHelper = new RequestHelper({});

    requestHelper.fetch(null, {
      success(model, data) {
        console.log("RES: ", data);
      },
      error() {
        console.log("ERROR in get voucher types");
      },
    });
  },

  _toggleAccordion() {
    if (this.getUI("accordionContent").hasClass("hide")) {
      $("#orders-reservations-accordion .accordion-item .accordion-content").addClass("hide");

      this.getUI("accordionContent").removeClass("hide");
    } else {
      this.getUI("accordionContent").addClass("hide");
    }
  },

  _printRentalContract(target) {
    const t = $(target.currentTarget),
      rid = t.attr("data-inb-reservation");

    /*let ref = "" + getApiHost();
        ref = ref.slice(0, -4) + "/rental_contract/" + rid + "/1";
        window.open(ref,'_blank');*/

    getDocHandler(
      "/rental_contract/" + rid,
      "GET",
      "application/pdf",
      this.t("reservation") + "-" + this.model.attributes.order.order_nbr + ".pdf",
      "",
      rid,
    );
  },

  onChangeContingentId() {
    this._buildPricetariffSelectList();

    // Update price field label if contingent has no pricetariff
    this.$el
      .find(".reservation-price-wrapper select.reservation-price__select-pricetariff")
      .trigger("change");

    // Change display of form elements according to resourcetype of contingent
    // (e.g. "data-inb-restype='4'" would show all fields related to appointment booking)
    const rtid = this.contingents.get(this.model.get("contingent_id")).get("resourcetype_id");

    this.$el.attr("data-inb-restype", rtid);

    if (rtid === 4 && this.model.get("appointment_id") !== "") {
      // Set input val similiar to AppointmentPicker:76
      // (Though event-name/-object is missing in reservation)
      this.$el
        .find('input[name="appointment_id"]')
        .val(
          moment(this.model.get("begin")).format("D. MMMM HH:mm") +
            " - " +
            moment(this.model.get("end")).format("D. MMMM YYYY HH:mm"),
        );
    } else {
      this.$el.find('input[name="appointment_id"]').val("");
    }
    /*  let products = this._getAvailableProducts(this.model.get('contingent_id'));
        if(products !== null){
            
            
            this.render();
        }    */
  },

  _toggleProductsOverviewView() {
    const begin_location = this.locations.get(this.model.get("begin_location")),
      end_location = this.locations.get(this.model.get("end_location"));

    new ProductsOverviewList({
      begin: this.model.get("begin"),
      end: this._getBlockedEnd(), //this.model.get('end'),
      begin_location,
      end_location,
      parentReservation: this,
      default: true,
      contingent_id: this.model.get("contingent_id"),
    });
  },

  _getBlockedEnd() {
    // If reservation.blocked_end was set: increase end date by x days
    if (
      this.model.get("blocked_end") !== "" &&
      this.model.get("blocked_end") !== null &&
      Number(this.model.get("blocked_end")) !== NaN
    ) {
      let end = moment(this.model.get("end"), "YYYY-MM-DD HH:mm");
      end.add(this.model.get("blocked_end"), "days");

      return end.format("YYYY-MM-DD HH:mm") + ":00";
    }

    return this.model.attributes.end + (this.model.attributes.end.length < 19 ? ":00" : "");
  },
  /**
   * Called after changes on any form element
   * Indicate whether reservation has to be saved (= was modified)
   */
  onChangeObserver(ref) {
    if (
      typeof this._ui !== "undefined" &&
      typeof this.getUI("reservationRequiresSave") !== "undefined" &&
      typeof this.getUI("accordionContent") !== "undefined"
    ) {
      if (typeof ref === "function" && this.getUI("accordionContent").hasClass("hide")) {
        return; // observer has been called by price update but reservation form is closed -> do not set as unsaved
      }
      this.model.set("_requiresSave", true);
      this.getUI("reservationRequiresSave").removeClass("hide");
    }
  },

  _setSummedProducts() {
    this._reservationContingentsListViews = this._reservationProductsListViews = {};
    this.$el.find(".reservation-contingents-list").html("");

    this.$el.find(".reservation-products-list").html("");
    const that = this;
    _.each(this.model.get("summedProducts"), function (collection, key) {
      if (typeof collection.models[0] === "undefined") {
        delete that.model.get("summedProducts")[key];
        return;
      }
      const id = collection.models[0].get("id"),
        el = that.$el
          .find(".reservation-contingents-list")
          .append(`<div class="product-${id}"></div>`)
          .find(".product-" + id);

      that._reservationProductsListViews[id] = new ReservationProductsList({
        collection,
        el,
        reservationView: that,
      });
    });
    this.$el.find(".products__add").remove();
    this.$el.find(".reservation-products-list").each(function () {
      $(this).append(`
                <footer class="row products__add text-center " style="width:100%;">
                    <p style="text-align: center;width:100%;">
                    <a href="#" class="_button round small hollow">
                        <i class="fi fi-_thumbnails"></i> ${that.t("add_${a}", { a: that.t("product") })}
                    </a>
                    </p>
                </footer>
                `);
    });
  },

  _getAvailableProducts(contingentId) {
    const RequestHelper = Backbone.Model.extend({
      url: "/products/getRelatedProducts/" + contingentId,
    });

    const requestHelper = new RequestHelper().fetch({
      success(model, response) {
        return response.related_products;
      },
      error() {
        return null;
      },
    });
  },

  /**
   * Render list of available pricetariffs for the selected contingent
   */
  _buildPricetariffSelectList() {
    const contingent_id = this.model.get("contingent_id"),
      el = this.$el.find(".reservation-price-wrapper");

    if (contingent_id !== "") {
      let pricetariffs = [],
        _pricetariffsBuffer = {};
      _.each(this.pricetariffs.models, (pricetariff) => {
        _.each(pricetariff.get("products"), (product) => {
          _.each(this.contingents.models, (contingent) => {
            if (contingent.id === Number(contingent_id)) {
              let prods = contingent.get("products");
              if (typeof prods[0] !== "undefined") {
                if (
                  prods[0].id === product.id &&
                  typeof _pricetariffsBuffer[pricetariff.get("id")] == "undefined"
                ) {
                  _pricetariffsBuffer[pricetariff.get("id")] = true;
                  pricetariffs.push({ id: pricetariff.get("id"), name: pricetariff.get("name") });
                }
              }
            }
          });
        });
      });

      if (pricetariffs.length === 0) {
        // Option "No price" should only be selectable when no pricetariff is assigned
        // to the active contingent
        pricetariffs.push({ id: "", name: "- " + this.t("reservation_no_price") + " -" });
      }

      const activePricetariffId =
        typeof this.model.get("contingents_reservations") !== "undefined" &&
        typeof this.model.get("contingents_reservations")[0] !== "undefined"
          ? this.model.get("contingents_reservations")[0].pricetariff_id
          : null;

      const priceTariffsPerContingent = _.reduce(
        pricetariffs,
        (memo, pricetariff) => {
          const selectedAttr =
            pricetariffs.length === 1 || pricetariff.id === activePricetariffId
              ? 'selected="selected"'
              : "";

          return (
            memo +
            `<option
                value="${pricetariff.id}"
                ${selectedAttr}>
                ${pricetariff.name}
            </option>`
          );
        },
        "",
      );

      el.find("select.reservation-price__select-pricetariff")
        .removeClass("hide")
        .html(priceTariffsPerContingent);
    } else {
      // @todo
      return;
    }
  },

  _showPrice(price) {
    if (price.price == null) {
      return;
    }

    if (typeof price.price_info != "undefined") {
      price.info = price.price_info;
    }

    this.$el.find(".reservation-price__true").removeClass("hide");
    this.$el.find(".reservation-price__false").addClass("hide");
    // @todo use generic, lang-dependent format helper class
    this.$el.find(".reservation-price__total").html(FormatHelper.currencyFormat(price.price));
    this.$el
      .find(".reservation-price__info")
      .html(
        price.info.toString().replace(".", ",").replace(/Days/g, "Tag(e)").replace(/for/g, "für"),
      );
  },

  _hidePrice(errorMsg) {
    if (typeof errorMsg == "undefined") {
      errorMsg = this.t("price_error_no_prices_found_for_tariff");
    }

    this.$el.find(".reservation-price__true").addClass("hide");
    this.$el.find(".reservation-price__false").removeClass("hide");
    this.$el.find(".reservation-price__error").html(errorMsg);
  },

  /**
   * Use the selected pricetariff and booking data to calculate and render
   * the total reservation cost.
   */
  _fetchPrice() {
    // @todo After reservation.pricetariff_id has been implemented,
    // set this value as selected on __select-price
    const user_id = Biscuit.get("user.id"),
      that = this,
      amount = this.model.get("amount"),
      tariff_id = this.$el.find("select.reservation-price__select-pricetariff").val(),
      contingents_res = this.model.get("contingents_reservations"),
      voucher_code =
        contingents_res !== undefined && contingents_res.length > 0
          ? contingents_res[0].voucher_code
          : "",
      begin = this.model.get("begin").toString(),
      end = this.model.get("end").toString(),
      contingent_id =
        typeof this.model.get("contingent_id") !== "undefined"
          ? this.model.get("contingent_id").toString()
          : null;

    // #VSCodeColourMindfuck:
    if (
      !this._fetchingPriceInProgress &&
      amount !== "" &&
      Number(amount) !== "" &&
      this.model.get("begin") !== "" &&
      this.model.get("end") !== "" &&
      contingent_id !== null
    ) {
      this._fetchingPriceInProgress = true;

      this.getUI("rollingLoader").fadeIn("fast");
      const voucherFullInput = this.$el.find(this.ui["voucherFullInput"]);
      let result = {
        pricetariff_id: tariff_id,
        count_of_contingents: amount,
        contingent_id: Number(contingent_id),
        begin: begin,
        end: end,
        user_id: user_id,
        voucher_code: this.showPriceWrapper ? voucherFullInput.value : null,
      };

      const getPriceHelper = new GetPriceHelper(),
        that = this;
      result.Products = MapProductsFromRawToGetPrice(this._reservationProductsListViews);
      /* 'tariff_id' => null, count_of_contingents' => 0,
                    'count_of_children' => 0, 'duration' => null */
      getPriceHelper.save(result, {
        success(model, response) {
          let offset = 0;
          _.each(that._reservationProductsListViews, function (view) {
            if (typeof view.injectPricesIntoChildrenProductViews === "function") {
              view.injectPricesIntoChildrenProductViews(response.price.Products, offset);
              offset += view.collection.models.length;
            }
          });
          if (response.price.info == "") {
            that._hidePrice();
          } else {
            that._showPrice(response.price);
            that.model.set("price", response.price.price);
          }
          if ($("input[name=total_price]").length > 0) {
            $("input[name=total_price]")[0].value =
              response.price.live_order_price + " " + Biscuit.getClientCurrency();
          }
          window.setTimeout(() => {
            that._fetchingPriceInProgress = false;
          }, 250);

          if (typeof that._ui !== "undefined") {
            that.getUI("rollingLoader").fadeOut("fast");
          }
        },
        error(model, response) {
          that._hidePrice(that.t("price_error_fetch"));
          that._fetchingPriceInProgress = false;

          if (typeof that._ui !== "undefined") {
            that.getUI("rollingLoader").fadeOut("fast");
          }
        },
      });
    }
  },

  getPrice() {
    let result = {
      user_id: Biscuit.get("user.id"),
      pricetariff_id: this.$el.find("select.reservation-price__select-pricetariff").val(),
      count_of_contingents: Number(this.model.get("amount")),
      contingent_id: Number(this.model.get("contingent_id")),
      begin: this.model.get("begin").toString(),
      end: this.model.get("end").toString(),
    };
    result.Products = MapProductsFromRawToGetPrice(this._reservationProductsListViews);
    const getPriceHelper = new GetPriceHelper(),
      that = this;
    getPriceHelper.save(result, {
      success(model, data) {
        let offset = 0;
        _.each(that._reservationProductsListViews, function (view) {
          if (typeof view.injectPricesIntoChildrenProductViews === "function") {
            view.injectPricesIntoChildrenProductViews(data.price.Products, offset);
            offset += view.collection.models.length;
          }
        });

        if (data.price.info == "") {
          that._hidePrice();
        } else {
          that._showPrice(data.price);
          that.model.set("price", data.price.price);
        }
        if ($("input[name=total_price]").length > 0) {
          $("input[name=total_price]")[0].value =
            data.price.live_order_price + " " + Biscuit.getClientCurrency();
        }

        window.setTimeout(() => {
          that._fetchingPriceInProgress = false;
        }, 250);

        if (typeof that._ui !== "undefined") {
          that.getUI("rollingLoader").fadeOut("fast");
        }
      },
      error() {
        that._hidePrice(that.t("price_error_fetch"));
        that._fetchingPriceInProgress = false;

        if (typeof that._ui !== "undefined") {
          that.getUI("rollingLoader").fadeOut("fast");
        }
      },
    });
  },

  _getAmountResourcesByContingent(cid = null) {
    if (_.isNull(cid)) {
      return;
    }

    // Or use endpoint for that via GetContingentNumbersAvailable
    // Or, if appointment, use maximum numbers setted privately via AppointmentPicker
    let number_active = this.contingents.get(cid).getNumbersByDay(this.model.get("begin"));

    if (typeof number_active === "undefined") {
      return [{ label: this.t("contingent_empty"), value: 0 }];
    }

    let result = [];

    for (let i = 1; i <= number_active.number; i++) {
      result.push({ label: i, value: i });
    }

    return result;
  },

  saveReservation() {
    // amount is the selected attribute -> set also amount in contingents_reservation

    const that = this;

    this.getUI("errorLabel").addClass("hide");

    // Does exactly what OffCanvasBehavior does...
    //$(this.$el.find('form')).foundation('validateForm');

    if (this.model.isValid() && !this.$el.find("form .is-invalid-input").length) {
      // Submit booking form

      if (that.getOption("preventFromSubmit") || that._saveRequestInProgress) {
        return false; // required for QuickOrderForm
      }

      that._saveRequestInProgress = true;

      const pricetariff = Number(
        this.$el.find("select.reservation-price__select-pricetariff").val(),
      );

      this.$el
        .find('form button[type="submit"]')
        .prepend('<img class="rollingLoader" src="assets/img/rolling_loader.svg" />');

      // @todo use InboomaBaseModel mixin
      this.model = OffCanvasBehavior.prototype.normalizeModel(this.model);
      this.model.attributes.begin = OffCanvasBehavior.prototype.makeApiTime(
        this.model.get("begin"),
      );
      this.model.attributes.end = OffCanvasBehavior.prototype.makeApiTime(this.model.get("end"));
      if (
        typeof this.model.attributes.blocked_begin !== "undefined" &&
        this.model.attributes.blocked_begin !== ""
      ) {
        that.model.set("manualBuffertime", true);
      }
      if (
        typeof this.model.attributes.blocked_end !== "undefined" &&
        this.model.attributes.blocked_end !== ""
      ) {
        that.model.set("manualBuffertime", true);
      }
      this.model.set("client_id", Number(Biscuit.get("user.client_id")));
      this.model.set("products", MapProductsFromRawToSave(that._reservationProductsListViews));
      // Set appointments join data
      const rtid = that.contingents.get(this.model.get("contingent_id")).get("resourcetype_id");

      if (typeof rtid !== "undefined" && Number(rtid) === 4) {
        delete this.model.attributes.appointment_id;
      }

      delete this.model.attributes.checkins;

      // Set contingents._joinData
      // https://rest-api-docs-internal.inbooma.net/#/Reservation/post_reservations
      this.model.set("contingents", [
        {
          id: this.model.get("contingent_id"),
          _joinData: {
            amount: this.model.get("amount"),
          },
        },
      ]);

      // Set contingents_reservations
      let orderItem = {};

      const contingents_reservations = this.model.get("contingents_reservations");

      if (
        typeof contingents_reservations !== "undefined" &&
        typeof contingents_reservations[0] !== "undefined"
      ) {
        orderItem = {
          order_item_price_id: contingents_reservations[0].order_item_price_id,
          is_updated: true,
        };
      }

      if (typeof pricetariff === "undefined" || pricetariff === 0 || pricetariff === NaN) {
        // No pricetariff selected
        // orderItem.pricetariff_id = null;
      } else {
        orderItem.pricetariff_id = pricetariff;
      }

      // proof if contingents_reservations with contingents_id has been already set - just update old value
      if (
        typeof this.model.attributes.contingents_reservations !== "undefined" &&
        this.model.attributes.contingents_reservations.length > 0
      ) {
        _.each(this.model.attributes.contingents_reservations, function (cres) {
          if (cres.contingent_id == Number(that.model.get("contingent_id"))) {
            cres.amount = that.model.attributes.amount;
          }
        });
      } else {
        this.model.set("contingents_reservations", [
          {
            ...orderItem,
            amount: Number(this.model.get("amount")),
            contingent_id: Number(this.model.get("contingent_id")),
          },
        ]);
      }

      const value = that.model.get("_booking_time_differs");

      // Eventually, copy begin & end to blocked_begin & blocked_end
      if (value && that.model.get("begin") !== "" && that.model.get("end") !== "") {
        //   that.model.set('blocked_begin', that.model.get('begin'));
        //   that.model.set('blocked_end', that.model.get('end'));
      } else {
        that.model.attributes.blocked_begin = null;
        that.model.attributes.blocked_end = null;
      }

      // Blacklist approach
      // Similiar to _.omit
      // @todo Use whitelist approach as in BikesReservationForm
      delete this.model.attributes._booking_time_differs;
      delete this.model.attributes.contingent_id;
      delete this.model.attributes.price;
      delete this.model.attributes._price;
      delete this.model.attributes.discount;
      delete this.model.attributes.reservation_nbr;
      delete this.model.attributes.contingents;
      delete this.model.attributes.return_time_exceeded;
      delete this.model.attributes._requiresSave;
      /* delete this.model.attributes.requestedPriceData;
            delete this.model.attributes.tag_list;
            delete this.model.attributes.tags;
            delete this.model.attributes.tariff_price;
            delete this.model.attributes._locale;*/

      if (this.model.get("id") === "" || this.model.get("id") === null) {
        delete this.model.attributes.id;
      }

      const error = (model, xhr, options) => {
        that.$el.find(".rollingLoader").fadeOut("fast");

        new Notification({
          message: that.t("request_error"),
          duration: 5000,
          type: "warning",
          closeable: true,
          icon: "fi fi-x",
        });

        that._saveRequestInProgress = false;
      };

      this.model.save(null, {
        success(_model, response, options) {
          // Problem: Response object is not fully trustworthy
          // -> Refetch whole reservation

          that.$el.find(".rollingLoader").fadeOut("fast");

          that.model.fetch({
            success(__model) {
              new Notification({
                message: that.t("saved_${a}", { a: that.t("reservation") }, "capital"),
                duration: 5000,
                type: "success",
                closeable: true,
                icon: "fi fi-check",
              });

              that.model.set("_requiresSave", false);
              that._saveRequestInProgress = false;

              //  that.options.parent.get('reservations')
              //                     .set(that.model, { add:true, merge:true, remove:false });

              that.getUI("errorLabel").addClass("hide");

              that.model.trigger("changed");

              that.options.toggleOpen = false;

              if (
                typeof that._ui !== "undefined" &&
                that.getUI("reservationRequiresSave") !== "undefined"
              ) {
                that.getUI("reservationRequiresSave")[0].classList.add("hide");
              }

              that.initialize();
              that.render();
            },
            error,
          });
        },
        error,
      });
    } else {
      // Invalid form

      let error = that.t("form_validation_error");

      if (typeof that.model.validationError !== "undefined" && that.model.validationError !== "") {
        error = that.t(that.model.validationError);
      }

      that.getUI("errorLabel").removeClass("hide").html(error);

      return false;
    }
  },

  onRender() {
    let contingent = null;

    if (this.model.get("id") === "") {
      // Set default contingent

      if (this.contingents.models.length >= 1) {
        contingent = this.contingents.models[0].toJSON();
      } else {
        // No contingent added yet to client -> abort!

        if (confirm(this.t("reservations_error_no_contingents"))) {
          Backbone.history.navigate("contingents/add", { push: true });
        }

        return false;
      }
    } else {
      // We need an internal contingent_id for the contingent field in form
      // -> Map this.model.attributes.contingents[0] to this.model.attributes.contingent_id
      if (
        typeof this.model.get("contingents") !== "undefined" &&
        this.model.get("contingents").length
      ) {
        contingent = this.model.get("contingents")[0];

        if (typeof contingent["_joinData"] !== "undefined") {
          if (typeof contingent["_joinData"].price_info !== "undefined") {
            this._showPrice(contingent["_joinData"]);
          }
        }
      }

      this._fetchPrice();
    }

    this.model.set("contingent_id", contingent.id);

    // CSS selector will now hide/show resourcetype-specific fields:
    this.$el.attr("data-inb-restype", contingent.resourcetype_id);

    // A lil' bit of complexity that adresses different scenarios (e.g. re-rendering form)
    if (
      (typeof this.model.get("_booking_time_differs") === "undefined" ||
        this.model.get("_booking_time_differs")) &&
      this.model.get("blocked_begin") !== null &&
      this.model.get("blocked_begin") !== "" &&
      this.model.get("blocked_end") !== null &&
      this.model.get("blocked_end") !== "" &&
      (this.model.get("blocked_begin") !== this.model.get("begin") ||
        this.model.get("blocked_end") !== this.model.get("end"))
    ) {
      this.model.set("_booking_time_differs", true);
    } else {
      this.model.set("_booking_time_differs", false);
    }

    if (this.model.get("description")) {
      // For clients that previously used reservation.description
      // -> Can be removed after a while
      this.model.set("internal_note", this.model.get("description"));
      this.model.set("description", "");
    }

    const that = this,
      client_id = Number(Biscuit.get("user.client_id"));

    let fields = [];
    if (typeof this.model.get("_has_any_deleted_item") === "undefined") {
      fields = [
        /** resourcetypes:
         * 1 = Fahrzeuge (Vehicles) - Though handled by BikesReservationForm
         * 2 = Unterkünfte (Apartements) - UNUSED
         * 3 = Bikesharing
         * 4 = Termine (Appointments)
         */
        {
          name: "contingent_id",
          label: that.t("contingent", null, "capital"),
          control: "selector",
          required: true,
          options: _.map(that.contingents.models, (_contingent, key) => {
            let label = _contingent.get("name");

            if (typeof _contingent.get("locations") !== "undefined") {
              if (typeof _contingent.get("locations")[0] !== "undefined") {
                label += " (" + _contingent.get("locations")[0].name + ")";
              }
            }

            return { label, value: _contingent.get("id") };
          }),
          size: {
            large: "4",
            small: "12",
          },
          groupLabel: '<i class="fi fi-widget"></i>',
        },
        {
          name: "status",
          label: this.t("status", null, "capital"),
          control: "select",
          required: true,
          // @todo make disabled if reservation from past
          options: [
            // TODO: appRadio.get('order-select-states')
            {
              label: that.t("completed", null, "capital"),
              value: "completed",
              disabled: false,
            },
            {
              label: that.t("confirmed", null, "capital"),
              value: "confirmed",
              disabled: false,
            },
            {
              label: that.t("requested", null, "capital"),
              value: "requested",
              disabled: false,
            },
            {
              label: that.t("inprogress", null, "capital"),
              value: "inprogress",
              disabled: false,
            },
            {
              label: that.t("cancelled", null, "capital"),
              value: "cancelled",
              disabled: false,
            },
          ],
          extraTopClasses: ["minHeight79px"],
          size: {
            large: "4",
          },
        },
        {
          name: "amount",
          label: this.t("resources_amount", null, "capital"), // may change - see below!
          extraTopClasses: ["depend restype-1 restype-2 restype-3 restype-4"],
          options: [], // may change - see below"
          size: {
            large: "4",
          },
          required: true,
          control: Backform.SelectControl.extend({
            initialize() {
              Backform.SelectControl.prototype.initialize.apply(this, arguments);
              this.listenTo(this.model, "change:contingent_id change:begin", function () {
                if (that.$el.attr("data-inb-restype") === "4") {
                  // Appointment
                  this.field.set("label", that.t("person_s", null, "capital"));
                } else {
                  this.field.set("label", that.t("resources_amount", null, "capital"));
                }

                this.field.set(
                  "options",
                  that._getAmountResourcesByContingent(this.model.get("contingent_id")),
                );
                this.render();
              });
            },
          }),
        },
        {
          name: "begin",
          label: this.t("start", null, "capital"),
          control: "datetimepicker",
          //required: true,
          minDate: that.model.get("id") == "" ? new Date() : null,
          extraTopClasses: ["hide-group-label depend restype-1 restype-2 restype-3"],
          size: {
            small: "12",
            large: "6",
          },
          triggerPicker: "end",
        },
        {
          name: "end",
          label: this.t("end", null, "capital"),
          minDate: that.model.get("id") == "" ? new Date() : null,
          control: "datetimepicker",
          //required: true,
          extraTopClasses: ["hide-group-label depend restype-1 restype-2 restype-3"],
          size: {
            small: "12",
            large: "6",
          },
        },
        {
          name: "_booking_time_differs",
          control: "boolean",
          float: true,
          label: this.t("booking_time_differs"),
          extraTopClasses: ["depend restype-1 restype-2 restype-3"],
        },
        {
          name: "blocked_begin",
          label: this.t("begin_booking", null, "capital"),
          visible: (model) => model.get("_booking_time_differs"),
          minDate: that.model.get("id") == "" ? new Date() : null,
          extraTopClasses: ["hide-group-label depend restype-1 restype-2 restype-3"],
          size: {
            small: "12",
            large: "6",
          },
          control: Backform.DatetimepickerControl.extend({
            initialize() {
              Backform.DatetimepickerControl.prototype.initialize.apply(this, arguments);

              this.listenTo(this.model, "change:_booking_time_differs", function () {
                this.$el.toggleClass("hide", !this.model.get("_booking_time_differs"));
              });
            },
          }),
        },
        {
          name: "blocked_end",
          label: this.t("end_booking", null, "capital"),
          visible: (model) => model.get("_booking_time_differs"),
          minDate: that.model.get("id") == "" ? new Date() : null,
          extraTopClasses: ["hide-group-label depend restype-1 restype-2 restype-3"],
          size: {
            small: "12",
            large: "6",
          },
          control: Backform.DatetimepickerControl.extend({
            initialize() {
              Backform.DatetimepickerControl.prototype.initialize.apply(this, arguments);

              this.listenTo(this.model, "change:_booking_time_differs", function () {
                this.$el.toggleClass("hide", !this.model.get("_booking_time_differs"));
              });
            },
          }),
        },
        {
          name: "begin_location",
          label: this.t("location_of_checkin"),
          control: "selector",
          required: true,
          forceFirstSelected: true,
          extraTopClasses: ["depend restype-1 restype-2 restype-3"],
          options: _.map(this.locations.models, (location) => {
            return { label: location.get("name"), value: location.get("id") };
          }),
          size: {
            small: "6",
          },
        },
        {
          name: "end_location",
          label: this.t("location_of_checkout"),
          control: "selector",
          required: false,
          forceFirstSelected: true,
          extraTopClasses: ["depend restype-1 restype-2 restype-3"],
          options: _.map(this.locations.models, (location) => {
            return { label: location.get("name"), value: location.get("id") };
          }),
          size: {
            small: "6",
          },
        },
        {
          name: "reservation-contingents-list",
          control: "fillable",
        },
        {
          name: "reservation-products-list",
          control: "fillable",
        },
        {
          name: "appointment_id", // Though the AppointmentPicker also sets `begin`, `end` and `amount`
          label: this.t("select_${a}", { a: this.t("appointment") }, "capital"),
          // control: "appointmentpicker",
          extraTopClasses: ["depend restype-4"],
          size: {
            small: "12",
          },
          options: (model) => {
            return {
              client_id,
              contingent: that.contingents.get(model.get("contingent_id")),
              triggerHelperCollectionFetch: true,
            };
          },
          control: Backform.AppointmentpickerControl.extend({
            initialize() {
              Backform.AppointmentpickerControl.prototype.initialize.apply(this, arguments);

              this.listenTo(this.model, "change:contingent_id", function (__model, __value, d) {
                $(".pika-single").addClass("is-hidden");
                $(".appointments-popup-list").remove();

                const rtid = that.contingents
                  .get(this.model.get("contingent_id"))
                  .get("resourcetype_id");

                if (rtid === 4 && that.$el.attr("data-inb-restype") === "4") {
                  this._render = true;
                  this.render();
                } else {
                  this._render = false;
                }

                if (
                  typeof __model !== "undefined" &&
                  typeof __value !== "undefined" &&
                  __value !== this._old_contingent_id
                ) {
                  // Unselect all appointment related data
                  this.model.set("amount", 1);
                  this.model.set("appointment_id", "");
                  this.model.set("event_id", "");
                }

                this._old_contingent_id = this.model.get("contingent_id");
              });
            },
          }),
        } /*
                DEPRECATED - USE *_note from below
                {
                    name: "description",
                    label: this.t('notes',null,'capital'),
                    control: "textarea",
                    size : {
                        "small" : "12"
                    }
                },*/,
        {
          name: "external_note",
          label:
            this.t("notes_external", null, "capital") +
            " (" +
            this.t(
              "still_chars_available_${a}",
              {
                a:
                  255 -
                  (typeof this.model.get("external_note") !== "undefined" &&
                  this.model.get("external_note") !== null &&
                  this.model.get("external_note") !== ""
                    ? Number(this.model.get("external_note").length)
                    : 0),
              },
              "capital",
            ) +
            ")",
          control: "textarea",
          size: {
            small: "12",
          },
        },
        {
          name: "internal_note",
          label:
            this.t("notes_internal", null, "capital") +
            " (" +
            this.t(
              "still_chars_available_${a}",
              {
                a:
                  255 -
                  (typeof this.model.get("internal_note") !== "undefined" &&
                  this.model.get("internal_note") !== null &&
                  this.model.get("internal_note") !== ""
                    ? Number(this.model.get("internal_note").length)
                    : 0),
              },
              "capital",
            ) +
            ")",
          control: "textarea",
          size: {
            small: "12",
          },
        },
        /* {
                    name: "discount",
                    label: that.t('discount_in_percent',null,'capital'),
                    control: "input",
                    required : false,
                    size : {
                        "large" : "4",
                        "small" : "12"
                    },
                    placeholder: "0",
                    id: "ReservationDiscount"
                }*/
        {
          control: "button",
          label: that.t("save_${a}", { a: that.t("reservation") }),
          extraTopClasses: ["button-submit-wrapper"],
          extraClasses: [
            that.model.get("begin") == "" && that.model.get("end") == "" ? "hollow" : "",
          ],
          size: {
            small: "6",
          },
        },
      ];
    }

    if (that.model.get("id") === "") {
      fields.push({
        name: "remove-reservation",
        control: "uneditable-input",
        extraTopClasses: ["fake-link"],
        label: that.t("abort", null, "capital"),
        size: {
          small: "6",
        },
      });
    }

    this.form = new Backform.Form({
      el: that.$el.find("form"),
      model: that.model,
      fields: fields,
      events: {
        'keydown textarea[name="internal_note"]'(e) {
          let l = e.currentTarget.value.length;
          /*  if(typeof e.currentTarget.defaultValue !== 'undefined'){
                          l = e.currentTarget.defaultValue.length;
                      }*/
          if (e.originalEvent.keyCode === 8 || e.originalEvent.keyCode === 13) {
            if (l > 0) {
              l -= 1;
            }
          } else {
            l += 1;
          }
          if (l > 255) {
            return false;
          }
          that
            .$('textarea[name="internal_note"]')
            .parent("div")
            .parent("div")
            .children("label")
            .text(
              that.t("notes_internal", null, "capital") +
                " (" +
                that.t("still_chars_available_${a}", { a: 255 - Number(l) }, "capital") +
                ")",
            );
        },
        'keydown textarea[name="external_note"]'(e) {
          let l = e.currentTarget.value.length;
          /*if(typeof e.currentTarget.defaultValue !== 'undefined'){
                        l = e.currentTarget.defaultValue.length;
                    }*/

          if (e.originalEvent.keyCode === 8 || e.originalEvent.keyCode === 13) {
            if (l > 0) {
              l -= 1;
            }
          } else {
            l += 1;
          }
          if (l > 255) {
            return false;
          }
          that
            .$('textarea[name="external_note"]')
            .parent("div")
            .parent("div")
            .children("label")
            .text(
              that.t("notes_external", null, "capital") +
                " (" +
                that.t("still_chars_available_${a}", { a: 255 - Number(l) }, "capital") +
                ")",
            );
        },
        'change textarea[name="external_note"]'(e) {
          let l = e.currentTarget.value.length;
          // l += 1;
          if (l > 255) {
            alert(
              that.t(
                "text_limited_for_chars_${a}_${b}",
                {
                  a: that.t("notes_external", null, "capital"),
                  b: e.currentTarget.value.length - 254,
                },
                "capital",
              ),
            );
            e.currentTarget.value = e.currentTarget.value.substr(0, 255);
            that
              .$('textarea[name="external_note"]')
              .parent("div")
              .parent("div")
              .children("label")
              .text(
                that.t("notes_external", null, "capital") +
                  " (" +
                  that.t("still_chars_available_${a}", { a: 0 }, "capital") +
                  ")",
              );
            that.model.set("external_note", e.currentTarget.value);
          } else {
            that
              .$('textarea[name="external_note"]')
              .parent("div")
              .parent("div")
              .children("label")
              .text(
                that.t("notes_external", null, "capital") +
                  " (" +
                  that.t("still_chars_available_${a}", { a: 255 - Number(l) }, "capital") +
                  ")",
              );
          }
        },
        'change textarea[name="internal_note"]'(e) {
          let l = e.currentTarget.value.length;
          // l += 1;
          if (l > 255) {
            alert(
              that.t(
                "text_limited_for_chars_${a}_${b}",
                {
                  a: that.t("notes_internal", null, "capital"),
                  b: e.currentTarget.value.length - 254,
                },
                "capital",
              ),
            );
            e.currentTarget.value = e.currentTarget.value.substr(0, 255);
            that
              .$('textarea[name="internal_note"]')
              .parent("div")
              .parent("div")
              .children("label")
              .text(
                that.t("notes_internal", null, "capital") +
                  " (" +
                  that.t("still_chars_available_${a}", { a: 0 }, "capital") +
                  ")",
              );
            that.model.set("internal_note", e.currentTarget.value);
          } else {
            that
              .$('textarea[name="internal_note"]')
              .parent("div")
              .parent("div")
              .children("label")
              .text(
                that.t("notes_internal", null, "capital") +
                  " (" +
                  that.t("still_chars_available_${a}", { a: 255 - Number(l) }, "capital") +
                  ")",
              );
          }
        },

        "click .button"(ev) {
          ev.preventDefault();
          that.saveReservation();
        },
        "click .remove-reservation"(ev) {
          // Abort "add reservation" process by removing the unsaved model
          // from order and close reservationForm

          ev.preventDefault();

          if (confirm(that.t("really_remove"))) {
            const onDestroyModel = () => {
              that.$el.fadeOut("fast");

              new Notification({
                message: that.t("removed_${a}", { a: that.t("reservation") }, "capital"),
                duration: 5000,
                closeable: true,
                icon: "fi fi-trash",
              });

              that.model.trigger("changed");
              that.destroy();
            };

            that.model.destroy({
              success() {
                onDestroyModel();
              },
              error() {
                onDestroyModel();
              },
            });
          }
        },
      },
    }).render();

    if (typeof this.model.get("_has_any_deleted_item") === "undefined") {
      // Price-form specific options
      this.$el
        .find(".reservation-price-wrapper")
        .insertBefore(that.$el.find(".button-submit-wrapper"));

      this.$el
        .find(".reservation-price-wrapper select.reservation-price__select-pricetariff")
        .on("change", function () {
          const pricetariff_id = this.value;
          let cont_reservations = that.model.attributes.contingents_reservations;
          if (typeof cont_reservations === "undefined" || cont_reservations == null)
            cont_reservations = [];

          if (pricetariff_id === null || pricetariff_id === "") {
            that._hidePrice(that.t("price_error_select_values_first"));
          }

          var _getPrice = false;
          for (var i = 0; i < cont_reservations.length; i++) {
            if (cont_reservations[i].pricetariff_id != this.value) {
              console.log("GET PRICE 2: ", that.model.attributes);
              _getPrice = true;
              break;
            }
          }
          if (_getPrice) that._fetchPrice();
        });

      this.$el.find(".discount.form-control").on("change", function () {
        that._fetchPrice();
      });

      this.model.trigger("change:contingent_id");
    } else {
      // Has any deleted item
      this.$(".reservation-price-wrapper").addClass("hide");

      this.getUI("errorLabel").removeClass("hide").html(this.t("remove_booking_first"));
    }
    this.model.on("removedProduct", function (productId) {
      // Called from ContingentsOverviewList::_saveContingentsToReservation()
      that._reservationProductsListViews[productId].destroy();
    });
    this._setSummedProducts();
    new Foundation.Abide(this.$el.find("form"), { liveValidate: true });

    this.onChangeContingentId();
  },
});
